module.exports = __webpack_public_path__ + "heart-blueprint-hazelnut-ice-cream.f59dd31ac26d497d18a4.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/heart-blueprint-hazelnut-ice-cream.svg
// module chunks = main